import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-tab-business',
  templateUrl: './profile-tab-business.component.html',
  styleUrls: ['./profile-tab-business.component.scss']
})
export class ProfileTabBusinessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
